import { HlAffix } from '@hongluan-ui/components/affix'
import { HlAlert } from '@hongluan-ui/components/alert'
import { HlAside } from '@hongluan-ui/components/aside'
import { HlAnchor } from '@hongluan-ui/components/anchor'
import { HlAnchorLink } from '@hongluan-ui/components/anchor-link'
import { HlAutocomplete } from '@hongluan-ui/components/autocomplete'
import { HlBacktop } from '@hongluan-ui/components/backtop'
import { HlBadge } from '@hongluan-ui/components/badge'
import { HlBreadcrumb } from '@hongluan-ui/components/breadcrumb'
import { HlBreadcrumbItem } from '@hongluan-ui/components/breadcrumb-item'
import { HlButton } from '@hongluan-ui/components/button'
import { HlCalendar } from '@hongluan-ui/components/calendar'
import { HlCarousel } from '@hongluan-ui/components/carousel'
import { HlCarouselItem } from '@hongluan-ui/components/carousel-item'
import { HlCarouselIndicator } from '@hongluan-ui/components/carousel-indicator'
import { HlCascader } from '@hongluan-ui/components/cascader'
import { HlCascaderPanel } from '@hongluan-ui/components/cascader-panel'
import { HlCheckbox } from '@hongluan-ui/components/checkbox'
import { HlCheckboxGroup } from '@hongluan-ui/components/checkbox-group'
import { HlColorPicker } from '@hongluan-ui/components/color-picker'
import { HlCol } from '@hongluan-ui/components/col'
import { HlCollapse } from '@hongluan-ui/components/collapse'
import { HlCollapseItem } from '@hongluan-ui/components/collapse-item'
import { HlCollapseTransition } from '@hongluan-ui/components/collapse-transition'
import { HlContainer } from '@hongluan-ui/components/container'
import { HlConfigProvider } from '@hongluan-ui/components/config-provider'
import { HlDatePicker } from '@hongluan-ui/components/date-picker'
import { HlDialog } from '@hongluan-ui/components/dialog'
import { HlDropdown } from '@hongluan-ui/components/dropdown'
import { HlDropdownItem } from '@hongluan-ui/components/dropdown-item'
import { HlDropdownMenu } from '@hongluan-ui/components/dropdown-menu'
import { HlForm } from '@hongluan-ui/components/form'
import { HlFormItem } from '@hongluan-ui/components/form-item'
import { HlFooter } from '@hongluan-ui/components/footer'
import { HlGroup } from '@hongluan-ui/components/group'
import { HlHeader } from '@hongluan-ui/components/header'
import { HlIcon } from '@hongluan-ui/components/icon'
import { HlImageViewer } from '@hongluan-ui/components/image-viewer'
import { HlInput } from '@hongluan-ui/components/input'
import { HlInputNumber } from '@hongluan-ui/components/input-number'
import { HlLayout } from '@hongluan-ui/components/layout'
import { HlList } from '@hongluan-ui/components/list'
import { HlListItem } from '@hongluan-ui/components/list-item'
import { HlLink } from '@hongluan-ui/components/link'
import { HlMain } from '@hongluan-ui/components/main'
import { HlMenu } from '@hongluan-ui/components/menu'
import { HlMenuItem } from '@hongluan-ui/components/menu-item'
import { HlMenuItemGroup } from '@hongluan-ui/components/menu-item-group'
import { HlMention } from '@hongluan-ui/components/mention'
import { HlOption } from '@hongluan-ui/components/option'
import { HlOptionGroup } from '@hongluan-ui/components/option-group'
import { HlPagination } from '@hongluan-ui/components/pagination'
import { HlPopper } from '@hongluan-ui/components/popper'
import { HlPopover } from '@hongluan-ui/components/popover'
import { HlProgress } from '@hongluan-ui/components/progress'
import { HlPanel } from '@hongluan-ui/components/panel'
import { HlRadio } from '@hongluan-ui/components/radio'
import { HlRadioGroup } from '@hongluan-ui/components/radio-group'
import { HlRow } from '@hongluan-ui/components/row'
import { HlScrollbar } from '@hongluan-ui/components/scrollbar'
import { HlSelect } from '@hongluan-ui/components/select'
// import { HlSelectV2 } from '@hongluan-ui/components/select-v2'
import { HlSegmented } from '@hongluan-ui/components/segmented'
import { HlSelector } from '@hongluan-ui/components/selector'
import { HlSlider } from '@hongluan-ui/components/slider'
import { HlSkeleton } from '@hongluan-ui/components/skeleton'
import { HlSkeletonItem } from '@hongluan-ui/components/skeleton-item'
import { HlSpinner } from '@hongluan-ui/components/spinner'
import { HlSwitch } from '@hongluan-ui/components/switch'
import { HlSimpleTable } from '@hongluan-ui/components/simple-table'
import { HlSteps } from '@hongluan-ui/components/steps'
import { HlStep } from '@hongluan-ui/components/step'
import { HlSubMenu } from '@hongluan-ui/components/sub-menu'
import { HlSubHeader } from '@hongluan-ui/components/sub-header'
import { HlTable } from '@hongluan-ui/components/table'
import { HlTableV2, HlAutoResizer } from '@hongluan-ui/components/table-v2'
import { HlTableColumn } from '@hongluan-ui/components/table-column'
import { HlTabs } from '@hongluan-ui/components/tabs'
import { HlTabPane } from '@hongluan-ui/components/tab-pane'
import { HlTag } from '@hongluan-ui/components/tag'
import { HlTimePicker } from '@hongluan-ui/components/time-picker'
import { HlTimeline } from '@hongluan-ui/components/timeline'
import { HlTimelineItem } from '@hongluan-ui/components/timeline-item'
import { HlTimeSelect } from '@hongluan-ui/components/time-select'
import { HlTooltip } from '@hongluan-ui/components/tooltip'
import { HlTour } from '@hongluan-ui/components/tour'
import { HlTourStep } from '@hongluan-ui/components/tour-step'
import { HlTransfer } from '@hongluan-ui/components/transfer'
import { HlTree } from '@hongluan-ui/components/tree'
import { HlTreeV2 } from '@hongluan-ui/components/tree-v2'
import { HlThumb } from '@hongluan-ui/components/thumb'
import { HlUpload } from '@hongluan-ui/components/upload'
import { HlWatermark } from '@hongluan-ui/components/watermark'
import { HlVirtualTable } from '@hongluan-ui/components/virtual-table'

import type { Plugin } from 'vue'

export default [
  HlAffix,
  HlAlert,
  HlAside,
  HlAnchor,
  HlAnchorLink,
  HlAutocomplete,
  HlAutoResizer,
  HlBacktop,
  HlBadge,
  HlBreadcrumb,
  HlBreadcrumbItem,
  HlButton,
  HlCalendar,
  HlCarousel,
  HlCarouselItem,
  HlCarouselIndicator,
  HlCascader,
  HlCascaderPanel,
  HlCheckbox,
  HlCheckboxGroup,
  HlColorPicker,
  HlCol,
  HlCollapse,
  HlCollapseItem,
  HlCollapseTransition,
  HlContainer,
  HlConfigProvider,
  HlDatePicker,
  HlDialog,
  HlDropdown,
  HlDropdownItem,
  HlDropdownMenu,
  HlForm,
  HlFormItem,
  HlFooter,
  HlGroup,
  HlHeader,
  HlIcon,
  HlImageViewer,
  HlInput,
  HlInputNumber,
  HlLayout,
  HlList,
  HlListItem,
  HlLink,
  HlMain,
  HlMenu,
  HlMenuItem,
  HlMenuItemGroup,
  HlMention,
  HlOption,
  HlOptionGroup,
  HlPagination,
  HlPopover,
  HlPopper,
  HlProgress,
  HlPanel,
  HlRadio,
  HlRadioGroup,
  HlRow,
  HlScrollbar,
  HlSelect,
  HlSegmented,
  HlSkeleton,
  HlSkeletonItem,
  // HlSelectV2,
  HlSelector,
  HlSpinner,
  HlSlider,
  HlSteps,
  HlStep,
  HlSubMenu,
  HlSubHeader,
  HlSwitch,
  HlTable,
  HlTableV2,
  HlTableColumn,
  HlSimpleTable,
  HlTabs,
  HlTabPane,
  HlTag,
  HlTimePicker,
  HlTimeline,
  HlTimelineItem,
  HlTimeSelect,
  HlTooltip,
  HlTour,
  HlTourStep,
  HlTransfer,
  HlTree,
  HlTreeV2,
  HlVirtualTable,
  HlThumb,
  HlUpload,
  HlWatermark,
] as Plugin[]
